var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m19.3333 2.54663-1.88-1.880004-7.45334 7.453334-7.45333-7.453334-1.880004 1.880004 7.453334 7.45333-7.453334 7.45334 1.880004 1.88 7.45333-7.4533 7.45334 7.4533 1.88-1.88-7.4533-7.45334z","fill":"#5d6568"}));
}

CloseIcon.defaultProps = {"fill":"none","height":"20","viewBox":"0 0 20 20","width":"20"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
